import CheckBox from "components/atoms/input/CheckBox";
import InputTextLine from "components/atoms/input/TextLine";
import { TextSm } from "components/atoms/text";

import filter from "datas/searchFilter";
import { InputChange } from "types/Form";

interface Props {
  priceLabel: string;
  prices: string[];
  onChagePrices: (prices: string[]) => void;
  onChangeLabel: (label: string) => void;
}

// 검색필터 - 단가
const InputPrice = ({
  prices,
  priceLabel,
  onChagePrices,
  onChangeLabel,
}: Props) => {
  // 체크박스 라벨 상태 업데이트 이벤트
  const handleChageTextPrice = ({
    price,
    index,
  }: {
    price: string;
    index: number;
  }) => {
    const newPrices = [...prices].map((p, i) => (i === index ? price : p));
    onChagePrices(newPrices);
  };

  // 체크 박스 상태 업데이트 이벤트
  const handleChange = ({
    event,
    price,
  }: {
    event: InputChange;
    price: { name: string; value: string[] };
  }) => {
    if (event.target.checked) {
      onChangeLabel(price.name);
      onChagePrices(price.value);
    } else {
      onChangeLabel("");
      onChagePrices(["", ""]);
    }
  };

  return (
    <div className="grid grid-cols-4 gap-y-5 mt-5 ml-3">
      {filter.prices.map((price) => {
        return (
          <div key={price.name} className="flex gap-5 items-center">
            <CheckBox
              name="prices"
              checked={price.name === priceLabel}
              onChange={(event) => handleChange({ event, price })}
              children={<TextSm className="ml-1">{price.name}</TextSm>}
            />
          </div>
        );
      })}
      <div className="flex gap-2 items-center ml-7">
        <InputTextLine
          placeholder="최소"
          value={prices[0]}
          onChange={({ target }) =>
            handleChageTextPrice({ price: target.value, index: 0 })
          }
          className="text-center !w-[100px]"
        />
        <span>-</span>
        <InputTextLine
          placeholder="최대"
          value={prices[1]}
          onChange={({ target }) =>
            handleChageTextPrice({ price: target.value, index: 1 })
          }
          className="text-center !w-[100px]"
        />
      </div>
    </div>
  );
};

export default InputPrice;
